import mediumZoom from 'medium-zoom'
import * as Turbo from '@hotwired/turbo'

document.addEventListener('turbo:load', function () {
  setupDisqus()
  initializeZoom()
})

function setupDisqus() {
  window.disqus_config = function () {
    this.language = document.querySelector('html').getAttribute('lang')
    this.page.identifier = document
      .querySelector('[data-disqus-canonical-url]')
      .getAttribute('data-disqus-canonical-url')
  }
}

window.addEventListener(
  'touchstart',
  function touched() {
    document.body.classList.add('slider-touch')
    window.removeEventListener('touchstart', touched, false)
  },
  false
)

// zoomable images in articles and images opting in via data-zoomable

function initializeZoom() {
  const zoomableImages = document.querySelectorAll(
    'article .content figure > img, img[data-zoomable]'
  )
  if (zoomableImages.length > 0) {
    mediumZoom(zoomableImages, {
      background: 'rgba(0, 0, 0, 0.8)'
    })
  }
}
